import { GlButton, GlDrawer, GlIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__ } from '~/locale';
import { DRAWER_Z_INDEX } from '~/lib/utils/constants';
import { groupingStrategyFor } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/board/grouping/index.js?vue3';
import { DISPLAY_SETTINGS_PAGE_GROUP_BY, DISPLAY_SETTINGS_PAGE_ROOT, VIEW_MODE_LIST, VIEW_MODE_BOARD } from '../../constants';
import WorkItemDisplaySettingsSort from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/list/components/work_item_display_settings_sort.vue?vue3';
import WorkItemDisplaySettingsMetadata from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/list/components/work_item_display_settings_metadata.vue?vue3';
import WorkItemDisplaySettingsUserPreferences from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/list/components/work_item_display_settings_user_preferences.vue?vue3';
import WorkItemDisplaySettingsGroupBy from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/list/components/work_item_display_settings_group_by.vue?vue3';
import WorkItemDisplaySettingsEmptyGroups from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/list/components/work_item_display_settings_empty_groups.vue?vue3';
export default {
    name: 'WorkItemDisplaySettingsDrawer',
    components: {
        GlButton,
        GlDrawer,
        GlIcon,
        WorkItemDisplaySettingsSort,
        WorkItemDisplaySettingsMetadata,
        WorkItemDisplaySettingsUserPreferences,
        WorkItemDisplaySettingsGroupBy,
        WorkItemDisplaySettingsEmptyGroups
    },
    i18n: {
        title: s__('WorkItems|Display options'),
        groupBy: s__('WorkItems|Group by'),
        goBack: __('Go back')
    },
    props: {
        open: {
            type: Boolean,
            required: true
        },
        headerHeight: {
            type: String,
            required: false,
            default: ''
        },
        fullPath: {
            type: String,
            required: true
        },
        workItemTypeId: {
            type: String,
            required: true
        },
        viewMode: {
            type: String,
            required: false,
            default: VIEW_MODE_LIST
        },
        sortOptions: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        sortKey: {
            type: String,
            required: false,
            default: ''
        },
        namespacePreferences: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        commonPreferences: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        isBoardEnabled: {
            type: Boolean,
            required: false,
            default: false
        },
        isServiceDeskList: {
            type: Boolean,
            required: false,
            default: false
        },
        isSavedView: {
            type: Boolean,
            required: false,
            default: false
        },
        page: {
            type: String,
            required: false,
            default: DISPLAY_SETTINGS_PAGE_ROOT
        }
    },
    emits: [
        'close',
        'sort',
        'update-settings',
        'page-change'
    ],
    computed: {
        hasSortOptions () {
            return this.viewMode !== VIEW_MODE_BOARD && this.sortOptions.length > 0;
        },
        isGroupByPage () {
            return this.page === DISPLAY_SETTINGS_PAGE_GROUP_BY;
        },
        isBoardMode () {
            return this.isBoardEnabled && this.viewMode === VIEW_MODE_BOARD;
        },
        groupByLabel () {
            return groupingStrategyFor('status')?.label ?? '';
        }
    },
    methods: {
        onClose () {
            this.$emit('close');
        },
        onSort (newSortKey) {
            this.$emit('sort', newSortKey);
        },
        onSettingsUpdate (input) {
            this.$emit('update-settings', input);
        },
        openGroupByPage () {
            this.$emit('page-change', DISPLAY_SETTINGS_PAGE_GROUP_BY);
        },
        backToRoot () {
            this.$emit('page-change', DISPLAY_SETTINGS_PAGE_ROOT);
        }
    },
    DRAWER_Z_INDEX
};
